<template>
  <div>
    <el-drawer title="添加货物" direction="ltr" :visible.sync="addPlanVisibleThree" :before-close="addPlanClose" size="60%">
      <div style="margin-left:10px;">
        <div style="margin:20px 0 30px 0;" v-for="(item,ix) in allDataList" :key="ix">
          <p>货物信息</p>
          <hr>
          <!-- <div>
            <div style="display: flex;">
              <div v-if="khFlag">不控货</div>

              <div v-if="!khFlag">
                <span style="margin-left:20px;">控货剩余量:</span>

                <span style="color:red">{{controlStockWeight}}</span><span> 吨 </span>
              </div>
            </div>
          </div> -->
          <el-table max-height="300px" border bordersize="mini" size="mini" ref="tabref" :data="item.list"
            style="width:100%" highlight-current-row :header-cell-style="{background:'#F5F5F5',color:'black'}">
            <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
            <el-table-column prop="number" align="center" label="操作" width="70">
              <template slot-scope="scope1">
                <el-button @click="tabDelClick(item,scope1.$index,ix)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="number" align="center" label="件数">
              <template slot-scope="scope1">
                <el-input v-model="scope1.row.number" @input="changeJianShu(scope1.row,scope1.row.number)"
                  v-number-input.float="0" maxlength="50" placeholder="输入件数" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="allWeight" align="center" label="重量（吨）">
              <template slot-scope="scope1">
                <el-input v-model="scope1.row.allWeight" v-number-input.float="3" maxlength="50" placeholder="输入重量"
                  size="mini" :disabled='scope1.row.disWeight' @blur="weightInput(scope1.row,scope1.row.allWeight)">
                </el-input>
              </template>
            </el-table-column>
            <el-table-column prop="availableNumber" align="center" label="客户可提"></el-table-column>
            <el-table-column prop="productTypeName" align="center" label="货物类型"></el-table-column>
            <el-table-column prop="specification" align="center" label="规格"></el-table-column>
            <el-table-column prop="steelMillName" align="center" label="产地"></el-table-column>
            <el-table-column prop="model" align="center" label="材质"></el-table-column>
          </el-table>
          <div>
            <span style="color:red">{{item.sumWeight}}</span><span> 吨 </span>
            <span> / </span><span style="color:red">{{item.num}}</span><span> 件</span>
          </div>
        </div>
      </div>
      <div class="footerBox">
        <el-button type="primary" @click="addPlanClose">取消</el-button>
        <el-button type="primary" @click="finishClick(1)" :loading='addLoading'>保存</el-button>
      </div>
      <el-drawer title="客户库存" :modal-append-to-body="false" size="70%" :visible.sync="addPlanVisibleThree" :modal="false"
        :before-close="addPlanClose" class="rightDrawer">
        <div style="margin:22px 0 0 10px;">
          <span style="font-size:15px;margin-left:10px;">规格：</span>
          <el-select v-model="specification" clearable filterable placeholder="请选择" style="width:170px;" size="mini">
            <el-option v-for="(item,index) in specificationData" :key="index" :label="item.specification"
              :value="item.specification"></el-option>
          </el-select>
          <el-button type="primary" size="mini" @click="searchClick" style="margin-left:8px;">查询</el-button>
          <el-button type="primary" size="mini" @click="chongZhi">重置</el-button>
        </div>
        <div style="margin:10px 0 0 10px;">
          <el-table size="mini" :data="detailsDataCopyAdd" ref="detailsDataCopyAdd" style="width:100%;" :cell-style="getCellStyle"
            :header-cell-style="{background:'#f5f5f5'}" @row-click="dianjixuanzhong" highlight-current-row>
            <el-table-column prop="availableNumber" align="center" label="客户可提"></el-table-column>
            <el-table-column prop="productTypeName" align="center" label="货物类型"></el-table-column>
            <el-table-column prop="specification" align="center" label="规格"></el-table-column>
            <el-table-column prop="steelMillName" align="center" label="产地"></el-table-column>
            <el-table-column prop="model" align="center" label="材质"></el-table-column>
          </el-table>
        </div>
      </el-drawer>
    </el-drawer>
  </div>
</template>

<script>
import {
  // JfgetTEmptyBillDriverList, // 取得人车信息
  JfgetEmptyBillStockWarehouse, // 添加出库计划 添加货物列表（来源手动）
  virtualControlBeanZy, // 调用控货接口
  getWeighingMethodList, // 判断计重方式
  JfgetTEmptyStockCustomerGroup,
  addEmptyBillDetailExpZy, // 添加出库计划确定
  surplusControlWeight, //
  cVirtualControlList,
  getCustomerForBill,
  getSpecificationListForSummary,
  addEmptyOutstockJanFaForBillOfSummary
} from '@/api/wms-stock.js'

const vhsrule =
    /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/
const idrule = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/
const phonerule = /^[1]([3-9])[0-9]{9}$/

export default {
  components: {},
  name: 'XinzengTidan',
  data () {
    return {
      subTableData: [],
      detailsDataCopyAdd: [],
      billId: '',
      controlStockWeight: '',
      obj: {},
      plateNumberOption: [],
      xuanzhongArr: null,
      primaryCustomerTaxId: '',
      secondaryCustomerTaxId: '',
      organizationId: '',
      allDataList: [],
      searchArr: [],
      parentData: {},
      jianShuArr: [],
      khFlag: false,
      addLoading: false,
      confirmLoadingB: false,
      paramsObject: {},
      plateNumberData: [],
      cheChuanNum: '',
      specificationData: [],
      specification: ''
    }
  },
  props: {
    addPlanVisibleThree: {
      type: Boolean,
      default: true
    },
    planData: {
      type: Object
    },
    chePai: {
      type: String
    }
  },
  watch: {
    planData: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val) {
          this.parentData = val
          console.log(this.parentData, 'this.parentData')
          this.primaryCustomerTaxId = val.primaryCustomerTaxId
          this.secondaryCustomerTaxId = val.secondaryCustomerTaxId
          this.billId = val.billId
          this.organizationId = val.organizationId
        }
      }
    }
  },
  created () {
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.finishClick()
      }
    }
  },
  mounted () {
    // this.getDriverList()
    this.driverData()
    this.getSpecificationListForSummary()
    // this.getPlateNumberListForSummary()
    this.getCustomerForBill()
  },
  methods: {
    // 材质是HRB500E就标称红色
    getCellStyle ({ row, column, rowIndex, columnIndex }) {
      if (column.property == 'model' && row.model == 'HRB500E') {
        return { color: 'red' }
      }
    },
    // 获取规格下拉框数据
    getSpecificationListForSummary () {
      getSpecificationListForSummary({
        primaryCustomerTaxId: this.primaryCustomerTaxId, // （一级货主id  必填）
        customerTaxId: this.secondaryCustomerTaxId // （二级货主id 必填）
      }).then(res => {
        this.specificationData = res
      }).catch(err => {
        this.$message.error(err.message)
      })
    },

    searchClick () {
      this.getCustomerForBill()
    },
    chongZhi () {
      this.cheChuanNum = ''
      this.specification = ''
      this.getCustomerForBill()
    },
    // 获取右边列表
    getCustomerForBill () {
      getCustomerForBill({
        // billId: this.billId, // （出库提单id  必填）
        specification: this.specification, // （规格 非必填）
        primaryCustomerTaxId: this.primaryCustomerTaxId,
        customerTaxId: this.secondaryCustomerTaxId
      }).then(res => {
        this.detailsDataCopyAdd = res
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    driverData () {
      let obj = {
        plateNumber: '',
        driverName: '',
        idNumber: '',
        telephone: '',
        billDriverId: ''
      }
      this.subTableData.push(obj)
    },
    // 点击
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      this.xuanzhongArr.primaryCustomerTaxId = this.primaryCustomerTaxId
      this.xuanzhongArr.customerTaxId = this.secondaryCustomerTaxId
      this.xuanzhongArr.stockCustomerId = row.stockCustomerId

      console.log(row, '2222')
      // 控货剩余
      // cVirtualControlList({
      //   oneCustomerTaxId: this.xuanzhongArr.primaryCustomerTaxId,
      //   twoCustomerTaxId: this.xuanzhongArr.customerTaxId,
      //   organizationId: localStorage.getItem('tenantCode'),
      //   pageNo: 1,
      //   pageSize: 20
      // }).then(res => {
      //   if (res.list.length !== 0) {
      //     // 控货
      //     this.khFlag = false
      //     // controlStockWeight
      //     res.list.forEach(item => {
      //       this.controlStockWeight = item.surplusControlWeight.toFixed(3)
      //     })
      //   } else {
      //     this.khFlag = true
      //   }
      //   // this.controlStockWeight = res
      //   //
      // }).catch(err => {
      //   this.$message.error(err.message)
      // })
      this.virtualControlBeanZy()
      this.getWeighingMethod()
      this.JfgetTEmptyStockCustomerGroup()
    },
    delClick (item, ix) {
      this.allDataList.splice(ix, 1)
    },
    tabDelClick (item, ix, index) {
      item.list.forEach((item1, index1) => {
        if (index1 == ix) {
          item.list.splice(ix, 1)
          if (item.list.length == 0) {
            item.num = 0
            item.sumWeight = 0
            this.delClick(item, index)
          } else {
            this.allDataList.forEach((item, index) => {
              this.$set(item, 'num', item.list.reduce((pre, cur) => {
                return pre / 1 + cur.number / 1
              }, 0))
              this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => {
                return pre / 1 + cur.allWeight / 1
              }, 0)).toFixed(3))
            })
          }
        }
      })
    },
    // 添加出库计划取消
    addPlanClose () {
      this.$emit('update:addPlanVisibleThree', false)
      this.$parent.getSeatchData()
    },
    // 出库提单 取得人车信息
    // getDriverList() {
    //   JfgetTEmptyBillDriverList({
    //     billId: this.billId
    //   }).then(res => {
    //     res.forEach(item => {
    //       this.plateNumberOption.push(item)
    //       console.log(this.chePai, 'this.chePai')
    //       if (this.chePai) {
    //         this.subTableData[0].plateNumber = this.chePai
    //       } else {
    //         this.subTableData[0].plateNumber = this.parentData.plateNumber.split(',')[0]
    //       }
    //       this.plateNumberOption.forEach(item => {
    //         if (this.subTableData[0].plateNumber == item.plateNumber) {
    //           this.subTableData[0].idNumber = item.idNumber
    //           this.subTableData[0].telephone = item.telephone
    //           this.subTableData[0].driverName = item.driverName
    //           this.subTableData[0].billDriverId = item.billDriverId
    //           console.log(this.subTableData[0].billDriverId, 'this.subTableData[0].billDriverId')
    //         }
    //       })
    //     })
    //   }).catch(err => {
    //     this.$message.error(err.message)
    //   })
    // },
    // 提货车号下拉框值改变
    plateNumChange (row, val) {
      if (val) {
        this.plateNumberOption.forEach((item) => {
          if (val == item.plateNumber) {
            this.subTableData[0].driverName = item.driverName
            this.subTableData[0].idNumber = item.idNumber
            this.subTableData[0].telephone = item.telephone
            this.subTableData[0].billDriverId = item.billDriverId
            console.log(row.billDriverId, 'row.billDriverId')
          }
        })
      } else {
        row.driverName = ''
        row.idNumber = ''
        row.telephone = ''
      }
    },
    // 判断计重方式
    getWeighingMethod () {
      getWeighingMethodList({
        productType: this.xuanzhongArr.productType
      }).then(res => {
        if (res.length > 0) {
          if (res[0].outWeighingMethod == 1) {
            this.$set(this.xuanzhongArr, 'disWeight', true)
          } else {
            this.$set(this.xuanzhongArr, 'disWeight', false)
          }
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 获取单件理重
    JfgetTEmptyStockCustomerGroup () {
      JfgetTEmptyStockCustomerGroup({
        primaryCustomerTaxId: this.primaryCustomerTaxId, // （一级货主id  必填）
        customerTaxId: this.secondaryCustomerTaxId, // （二级货主id 必填）
        productType: this.xuanzhongArr.productType, // （货物类型id  非必填）
        steelMillName: this.xuanzhongArr.steelMillName, // （产地  非必填）
        model: this.xuanzhongArr.model, // （材质 非必填）
        specification: this.xuanzhongArr.specification // （规格  非必填）
      }).then(res => {
        this.$set(this.xuanzhongArr, 'singletonWeight', res[0].singletonWeight)
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 调用控货接口
    virtualControlBeanZy () {
      virtualControlBeanZy({
        oneCustomerTaxId: this.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
        twoCustomerTaxId: this.secondaryCustomerTaxId, // （二级货主纳税人识别号  必填）
        organizationId: this.organizationId, // （仓储租户id  必填）
        productionPlaceName: this.xuanzhongArr.steelMillName, // （产地  必填）
        specificationName: this.xuanzhongArr.specification, // （规格  必填）
        materialName: this.xuanzhongArr.model, // （材质  必填）
        goodTypeName: this.xuanzhongArr.productTypeName // （货物类型名称  必填
      }).then(res => {
        console.log(JSON.parse(res), 'res')
        // controlPiece: 1  // 控件  0不控  1控
        // controlWeight: 1 // 控吨  0不控  1控
        // isEnable: 1    //控货不控货标识   1控  2不控
        if (res) {
          let isEnableObj = {}
          isEnableObj = JSON.parse(res)
          this.$set(this.xuanzhongArr, 'number', '')
          this.$set(this.xuanzhongArr, 'weight', '')
          this.$set(this.xuanzhongArr, 'allWeight', '')
          this.$set(this.xuanzhongArr, 'productTypeName', this.xuanzhongArr.productTypeName)
          this.$set(this.xuanzhongArr, 'billDetailId', this.xuanzhongArr.billDetailId)
          this.$set(this.xuanzhongArr, 'steelMillName', this.xuanzhongArr.steelMillName)
          isEnableObj.isEnable = 2
          // 控货
          if (isEnableObj.isEnable == '1') {
            // let str = `${isEnableObj.productionPlaceName ? isEnableObj.productionPlaceName : '_'}${isEnableObj.goodTypeName ? isEnableObj.goodTypeName : '_'}${isEnableObj.specificationName ? isEnableObj.specificationName : '_'}${isEnableObj.materialName ? isEnableObj.materialName : ''}`
            let str = (isEnableObj.productionPlaceName ? isEnableObj.productionPlaceName : '') + ',' +
                (isEnableObj.goodTypeName ? isEnableObj.goodTypeName : '') + ',' +
                (isEnableObj.specificationName ? isEnableObj.specificationName : '') + ',' +
                (isEnableObj.materialName ? isEnableObj.materialName : '')

            console.log(str, 'str')
            if (str == ',,,') {
              str = '总控'
            }
            this.$set(this.xuanzhongArr, 'cargoControlKey', str)
            if (this.allDataList.some(item => item.cargoControlKey == str)) {
              let index = this.allDataList.findIndex(item => item.cargoControlKey == str)
              this.allDataList[index].list.push(this.xuanzhongArr)
              this.allDataList[index].list = Array.from(new Set(this.allDataList[index].list))
            } else {
              let obj = {
                cargoControlKey: str,
                releaseFlag: 0,
                list: [],
                num: 0,
                sumWeight: 0,
                surplus: true,
                surplusControlWeight: isEnableObj.surplusControlWeight,
                surplusControlNumber: isEnableObj.surplusControlNumber,
                controlWeight: isEnableObj.controlWeight,
                controlPiece: isEnableObj.controlPiece,
                strictReminder: isEnableObj.strictReminder,
                isEnable: isEnableObj.isEnable
              }
              obj.list.push(this.xuanzhongArr)
              this.allDataList.push(obj)
            }
            console.log(this.allDataList, 'this.allDataList')
          } else {
            // 不控
            this.$set(this.xuanzhongArr, 'cargoControlKey', '不控货')
            if (this.allDataList.some(item => item.cargoControlKey == '不控货')) {
              let index = this.allDataList.findIndex(item => item.cargoControlKey == '不控货')
              this.allDataList[index].list.push(this.xuanzhongArr)
              this.allDataList[index].list = Array.from(new Set(this.allDataList[index].list))
            } else {
              let obj = {
                cargoControlKey: '不控货',
                list: [],
                num: 0,
                sumWeight: 0,
                surplus: false
              }
              obj.list.push(this.xuanzhongArr)
              this.allDataList.push(obj)
            }
            console.log(this.allDataList, 'this.111111')
          }
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    changeJianShu (row, val) {
      if (val) {
        this.$set(row, 'weight', (row.number / 1 * row.singletonWeight).toFixed(3))
        this.$set(row, 'allWeight', (row.number / 1 * row.singletonWeight).toFixed(3))
      } else {
        this.$set(row, 'weight', '0.000')
        this.$set(row, 'allWeight', '0.000')
      }

      this.allDataList.forEach((item, index) => {
        this.$set(item, 'num', item.list.reduce((pre, cur) => {
          return pre / 1 + cur.number / 1
        }, 0))
        this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => {
          return pre / 1 + cur.allWeight / 1
        }, 0)).toFixed(3))
      })
    },
    weightInput (row, val) {
      row.allWeight = Number(val).toFixed(3)
      row.weight = row.allWeight
      console.log(row.allWeight, row, 'row.allWeight')
      this.allDataList.forEach(item => {
        this.$set(item, 'num', item.list.reduce((pre, cur) => {
          return pre / 1 + cur.number / 1
        }, 0))
        this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => {
          return pre / 1 + cur.allWeight / 1
        }, 0)).toFixed(3))
      })
    },
    // 点击保存
    finishClick (n) {
      console.log(this.allDataList, 'this.allDataList')
      if (this.allDataList.length == 0) {
        this.$message.error('请选择右侧数据填写货物信息再点击保存')
      } else {
        let flagA = this.allDataList.every(item => item.num / 1 != 0)
        if (!flagA) {
          this.$message.error('件数不能为空或0')
          return
        }
        // let flagC = true
        // this.allDataList.forEach(item => {
        //   flagC = item.list.every(im => im.number < im.yuTiNumber || im.number == im.yuTiNumber)
        // })
        // if (!flagC) {
        //   this.$message.error('所输入的件数不能大于预提件数')
        //   return
        // }
        let flagD = true
        this.allDataList.forEach(item => {
          flagD = item.list.every(im => im.number < im.availableNumber || im.number == im.availableNumber)
        })
        if (!flagD) {
          this.$message.error('所输入的件数不能大于客户可提')
          return
        }

        if (flagA && flagD) {
          this.obj = {
            tEmptyBillMaster: {
              billId: this.billId
            },
            tEmptyBillDetailList: this.allDataList[0].list,
            tStockSummaryList: this.allDataList[0].list
          }
        }
        this.recursionCheck(0, n)

        // addEmptyBillDetailExpZy(this.obj).then(res => {
        //   this.$set(this.xuanzhongArr, 'singletonWeight', res[0].singletonWeight)
        //   this.addPlanVisibleThree = false
        // }).catch(err => {
        //   this.$message.error(err.message)
        // })
      }
    },
    // 调接口
    addOutStock (n) {
      if (n == '1') {
        this.addLoading = true
      } else {
        this.confirmLoadingB = true
      }
      addEmptyBillDetailExpZy(this.obj).then(res => {
        if (n == '1') {
          this.addLoading = false
          this.$emit('update:addPlanVisibleThree', false)
          this.$message.success('添加成功')
          this.addPlanClose()
          this.$emit('getTime')
        } else {
          this.confirmLoadingB = false
          this.$emit('update:addPlanVisibleThree', false)
          this.$message.success('添加成功')
          this.addPlanClose()
          this.$router.push({
            path: '/yycZhuangCheDan',
            query: {
              id: res
            }
          })
        }
      }).catch(err => {
        if (n == '1') {
          this.addLoading = false
        } else {
          this.confirmLoadingB = false
        }
        if (err.code == '-200') {
          this.$message.error(JSON.parse(err.message).msg)
          let cargoControlKey = JSON.parse(err.message).cargoControlKey
          if (cargoControlKey != '不控货') {
            let paramsObj = {}
            if (cargoControlKey == '总控') {
              paramsObj = {
                oneCustomerTaxId: this.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
                twoCustomerTaxId: this.secondaryCustomerTaxId, // （二级货主纳税人识别号  必填）
                organizationId: this.organizationId // （仓储租户id  必填）
              }
            } else {
              let controlKeyArr = cargoControlKey.split(',')
              paramsObj = {
                oneCustomerTaxId: this.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
                twoCustomerTaxId: this.secondaryCustomerTaxId, // （二级货主纳税人识别号  必填）
                organizationId: this.organizationId, // （仓储租户id  必填）
                productionPlaceName: controlKeyArr[0], // （产地  必填）
                goodTypeName: controlKeyArr[1], // （货物类型名称  必填
                specificationName: controlKeyArr[2], // （规格  必填）
                materialName: controlKeyArr[3] // （材质  必填）
              }
            }
            virtualControlBeanZy(paramsObj).then(res => {
              let isEnableObjB = JSON.parse(res)
              for (let index = 0; index < this.allDataList.length; index++) {
                console.log(this.allDataList[index], 'this.allDataList[index]')
                if (this.allDataList[index].cargoControlKey == cargoControlKey) {
                  this.allDataList[index].surplusControlWeight = isEnableObjB.surplusControlWeight
                  this.allDataList[index].surplusControlNumber = isEnableObjB.surplusControlNumber
                }
              }
            }).catch(err => {
              this.$message.error(err.message)
            })
          }
        } else {
          this.$message.error(err.message)
        }
      })
    },
    // 递归调用
    recursionCheck (index, n) {
      console.log('asdfasdfads', index)
      if (index < 0) {
        return
      }
      if (index == this.allDataList.length) {
        this.addOutStock(n)
      }
      if (index > this.allDataList.length) {
        // todo
      }
      const item = this.allDataList[index]
      // if (item) {
      if (item.isEnable == '1') {
        // 严控
        if (item.strictReminder == '0') {
          if (item.controlPiece == '1' && item.controlWeight == '1') {
            if (item.num > item.surplusControlNumber || item.sumWeight > item.surplusControlWeight) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的数据大于货权剩余量')
            } else {
              this.recursionCheck(index + 1, n)
            }
          } else if (item.controlPiece == '1') { // 控件
            if (item.num > item.surplusControlNumber) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数大于货权剩余量')
            } else {
              this.recursionCheck(index + 1, n)
            }
          } else if (item.controlWeight == '1') { // 控吨
            if (item.sumWeight > item.surplusControlWeight) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的重量大于货权剩余量')
            } else {
              this.recursionCheck(index + 1, n)
            }
          }
        } else {
          console.log('提示')
          // 提示
          if (item.controlPiece == '1') {
            if (item.num > item.surplusControlNumber) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数大于货权剩余量')
              return
            }
          }
          if (item.controlWeight == '1') {
            console.log('控吨')

            if (item.sumWeight > item.surplusControlWeight) {
              this.$confirm((item.cargoControlKey).replace(/,/g, '') + '所输入的重量大于货权剩余量，是否继续', '提示', {
                confirmButtonText: '继续',
                cancelButtonText: '取消',
                closeOnClickModal: false,
                type: 'warning'
              }).then(() => {
                item.releaseFlag = 1
                console.log(item.cargoControlKey, item.releaseFlag)
                this.recursionCheck(index + 1, n)
              }).catch(() => {})
            } else {
              this.recursionCheck(index + 1, n)
            }
          } else {
            this.recursionCheck(index + 1, n)
          }
        }
      } else {
        this.addOutStock(n)
      }
      // }
    }
  }
}

</script>

<style>

</style>
